module.exports = __webpack_public_path__ + "static/media/bola-01.51917600.jpg";